module.exports = __webpack_public_path__ + "static/media/header_icon.c96aa642.svg";